module.exports = __webpack_public_path__ + "avatar5.svg?dd5c15335c67f51d6247a891aa9fb91e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar5.svg
// module id = 141
// module chunks = 2